import React from 'react';

const SignalFlag = ({ flagName = "AP", status = "POSTPONED" }) => {
  return (
    <div className="instrument-widget flag-widget">
      <div className={`flag-icon ${flagName.toLowerCase()}`}>
        {/* Visual representation of the flag */}
        <div className="flag-stripe red"></div>
        <div className="flag-stripe white"></div>
      </div>
      <div className="counter-label">SIGNAL</div>
      <div className="status-tag flag-status">{status}</div>
    </div>
  );
};

export default SignalFlag;
